<template>
  <div class="result">
    <div class="loader" v-show="showLoader()">
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
      <div>Loading</div>
    </div>
    <div class="finished" v-show="showFinished()">
      <h3>My Canadian Coat of Arms</h3>
      <canvas id="canvas" ref="canvas" :width="imageWidth" :height="imageHeight"></canvas>
      <div class="col">
        <b-button-group>
          <b-button @click="downloadImg" class="download">
            <i class="fa fa-download" aria-hidden="true"></i>
            <span>Download Image</span>
          </b-button>
          <b-button @click="shareImage('Facebook')" class="facebook" :class="{loading: fbLoading}">
            <i class="share-loader fa fa-circle-o-notch fa-spin fa-fw"></i>
            <i class="media-icon fa fa-facebook" aria-hidden="true"></i>
            <span>Share on Facebook</span>
          </b-button>
          <b-button @click="shareImage('Twitter')" class="twitter" :class="{loading: twLoading}">
            <i class="share-loader fa fa-circle-o-notch fa-spin fa-fw"></i>
            <i class="media-icon fa fa-twitter" aria-hidden="true"></i>
            <span>Share on Twitter</span>
          </b-button>
        </b-button-group>
      </div>
      <p class="start-over" @click="restart">Like it? Share it! Don't like it? <a>Try Again</a></p>

      <!-- Share Modal -->
      <b-modal 
        id="shareModal" 
        :title="'Your image is ready to share on ' + sharePlatform" 
        :visible="shareModalState" 
        :hide-footer="true"
        @hidden="clearModal('share')"
        @cancel="clearModal('share')">
          <a 
          class="btn btn-lg btn-primary btn-block" 
          :class="{facebook: fbLoading, twitter: twLoading}" 
          :href="shareLink" 
          target="_blank" 
          @click="hideModal('share')">Share It!</a>
      </b-modal>

      <!-- Error Modal -->
      <b-modal 
        id="errorModal" 
        title="Sorry! There was an error sharing your image" 
        :visible="errorModalState" 
        :hide-footer="true"
        @hidden="clearModal('error')"
        @cancel="clearModal('error')">
          <b-button class="twitter" @click="hideModal('error')">OK</b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import 'blobjs'
import 'canvas-toBlob'
import fs from 'file-saver'
import FormData from 'form-data'

export default {

  name: 'Result',
  props: ['answers','loaded'],
  data () {
    return {
      defaultBacklink: 'http://globalnews.ca/',
      imageDrawn: false,
      imageName: '',
      imageWidth: 670,
      imageHeight: 609,
      sharePlatform: '',
      shareLink: '',
      shareModalState: false,
      errorModalState: false,
      fbLoading: false,
      twLoading: false,
      tweetText: "My #CanadianCoatofArms: ",
      service: {
        local: {
          path: '//static.local.globalnews.ca/coatofarms/public/',
          refLink: 'http://static.local.globalnews.ca/coatofarms/public/mygraphic.php'
        },
        prod: {
          path: '../',
          refLink: 'http://coatofarms.globalnews.ca/mygraphic.php'
        }
      }
    }
  },
  methods: {
    drawAllImages() {
      console.log('drawing images')

      // Canvas Object
      var canvas = this.$refs.canvas
      var ctx = canvas.getContext('2d')

      // load image assets from data urls
      Object.keys(this.answers).forEach(key => {
        // Don't show social media logo
        //if ( 'social' !== this.answers[key].logoType ) {
          ctx.drawImage(this.answers[key].image, 0, 0)
        //}
      })
    },
    // Same as regular image but the logo is placed higher so it is visible when shared
   /* getShareImage() {
      console.log('drawing share image')

      // Canvas Object
      var canvas    = document.createElement('canvas')
      canvas.width  = this.imageWidth
      canvas.height = this.imageHeight
      var ctx       = canvas.getContext('2d')

      // load image assets from data urls
      Object.keys(this.answers).forEach(key => {
        // Don't show regular logo
        if ( 'standard' !== this.answers[key].logoType ) {
          ctx.drawImage(this.answers[key].image, 0, 0)
        }
      })

      return canvas
    },*/
    getArrayLength(arr) {
      return arr.filter(function(e){return e!== undefined}).length
    },
    showLoader() {
      return this.loaded < this.getArrayLength(this.answers)
    },
    showFinished() {
      if (this.loaded >= this.getArrayLength(this.answers)) {
        if (!this.imageDrawn) {
          this.drawAllImages()
        }
        this.imageDrawn = true
        return true
      } else {
        return false
      }
    },
    downloadImg() {
      var canvas = this.$refs.canvas
      var ctx = canvas.getContext('2d')

      canvas.toBlob( function(blob) {
        fs.saveAs( blob, "coat-of-arms.png" )
      })
    },
    uploadImg() {
      //var canvas = this.getShareImage()
      var canvas = this.$refs.canvas
      var path = (this.isProd()) ? this.service.prod.path : this.service.local.path

      return axios({
        method: 'post',
        url: path + 'handle-temp.php',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: "imgData=" + canvas.toDataURL(),
      })
    },
    shareImage(platform) {
      var _self = this
      
      if ('Facebook' === platform) {
        this.fbLoading = true
      } else if ('Twitter' === platform) {
        this.twLoading = true
      }
      
      if (this.imageName.length > 0) {
        var refLink = _self.generateReferralLink()
        _self.generateShareCode(platform, refLink)
      } else {
        var request = this.uploadImg()
        request.then(function (response) {
          console.log(response)

          if (!response || !response.data || !response.data.fileName) {
            throw "error uploading image"
          }

          _self.imageName = response.data.fileName.split('.')[0]
          var refLink = _self.generateReferralLink()
          _self.generateShareCode(platform, refLink)
          console.log(refLink)
        })
        .catch(function (error) {
          console.log(error)
          _self.showModal('error')
        })
      }
    },
    generateReferralLink() {
      var refLink = (this.isProd()) ? this.service.prod.refLink : this.service.local.refLink
      var fileName = this.imageName
      var backLink = this.getBacklink()
      return refLink + '?name=' + encodeURIComponent(fileName) + '&ref=' + encodeURIComponent(backLink)
    },
    generateShareCode(platform, refLink) {
      if ('Facebook' === platform) {
        this.shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(refLink)
      } else if ('Twitter' === platform) {
        this.shareLink = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.tweetText) + encodeURIComponent(refLink)
      }
      this.sharePlatform = platform
      this.showModal('share')
      console.log(this.shareLink)
    },
    isProd() {
      // replace with local hostname here
      return 'static.local.globalnews.ca' !== window.location.hostname
    },
    getBacklink() {
      return (document.referrer.length > 0) ? document.referrer : this.defaultBacklink
    },
    showModal(type) {
      if ('share' === type) {
        this.shareModalState = true
      } else if ('error' === type) {
        this.errorModalState = true
      }
    },
    hideModal(type) {
      if ('share' === type) {
        this.shareModalState = false
      } else if ('error' === type) {
        this.errorModalState = false
      }
    },
    clearModal(type) {
      this.fbLoading = false
      this.twLoading = false
      this.hideModal(type)
    },
    restart() {
      this.imageDrawn = false
      this.imageName = ''
      this.sharePlatform = ''
      this.shareLink = ''
      this.$emit('restart')
    }
  }
}
</script>

<style scoped>
.loader {
  margin: 110px auto;
}

.loader div {
  margin-top: 20px;
  font-size: 24px;
}

h3 {
  padding: 0 15px;
}

canvas {
  width: 100%;
  height: auto;
}

.btn-group {
  width: 100%;
}

button {
  width: 33.33333%;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
}

button i {
  font-size: 24px;
}

.btn-group button span {
  display: none;
}

button.download {
  background: #ccc;
  border-color: #ccc;
}

button.facebook, #shareModal a.btn.facebook {
  color: #fff;
  background: #3b5998;
  border-color: #3b5998;
}

button.twitter, #shareModal a.btn.twitter {
  color: #fff;
  background: #1da1f2;
  border-color: #1da1f2;
}

.start-over {
  padding: 0 15px;
  margin: 15px 0 0 0;
}

.start-over a {
  color: #428bca;
  cursor: pointer;
  white-space: nowrap;
}

.start-over a:hover {
  color: #2c6290;
}

button .share-loader {
  display: none;
}

button.loading .share-loader {
  display: inline-block;
}

button.loading .media-icon {
  display: none;
}

@media (min-width: 560px) {
  .btn-group button i {
    display: none;
  }

  .btn-group button span {
    display: inline;
  }

  button.loading span {
    display: none;
  }
}

@media (min-width: 600px) {
  canvas {
    width: 95%;
  }
}

</style>



// WEBPACK FOOTER //
// Result.vue?77dce8ba